import React from "react";
import { useState } from "react";
import {
  IoIosAddCircleOutline,
  IoIosRemoveCircleOutline,
} from "react-icons/io";
import { MdOutlineArticle } from "react-icons/md";
import ResizableBox from "../common/ResizeableBox";

export default function LineupSidebar({ setIsOpenProceduresPopup }) {
  const [data, setData] = useState([
    {
      title: "SN2_526_M_TA03",
      isExpand: false,
      children: [
        { number: 10 },
        { number: 20 },
        { number: 30 },
        { number: 40 },
        { number: 50 },
      ],
    },
    {
      title: "SN2_526_M_TA04",
      isExpand: false,
      children: [{ number: 10 }, { number: 20 }, { number: 30 }],
    },
    {
      title: "SN2_526_M_TA05",
      isExpand: false,
      children: [
        { number: 10 },
        { number: 20 },
        { number: 30 },
        { number: 40 },
      ],
    },
  ]);

  // Toggle expand/collapse for one parent row
  const toggleExpand = (index) => {
    setData((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, isExpand: !item.isExpand } : item
      )
    );
  };
  return (
    <div className="flex flex-col custom-scrollbar pr-2.5">
      <ResizableBox
        direction="vertical"
        initialSize={400}
        minSize={150}
        maxSize={600}
      >
        <div className="p-2.5 pr-0 flex h-full flex-col gap-2.5">
          <div className="py-2.5 flex items-center flex-wrap gap-3">
            <h5 className="text-[#242424] text-[12px] font-normal whitespace-nowrap">
              절차서
            </h5>
            <button
              onClick={() => setIsOpenProceduresPopup(true)}
              className="text-[11px] text-[#08F] text-left "
            >
              [999429] OH-526-01 SN2_526_M_TA01
            </button>
          </div>
          {/* table/search result  */}

          <div className="w-full overflow-auto custom-scrollbar max-h-full pb-1 ">
            <table className="flex-1 w-full text-[12px] text-[#242424] text-center border border-[#C9C9C9]/30 border-t-0 whitespace-nowrap">
              <thead className="sticky top-0">
                <tr className="font-normal divide-x divide-[#C9C9C9]/30 bg-[#DBDBDB]">
                  <th className="py-1 px-2.5 font-normal">순서</th>
                  <th className="py-1 px-2.5 font-normal">값</th>
                  <th className=" px-2.5 font-normal">
                    태그 <br />
                    설정
                  </th>
                  <th className="px-2.5 font-normal">
                    태그 <br />
                    해제
                  </th>
                  <th className="px-2.5"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((it, idx) => (
                  <React.Fragment key={idx}>
                    {/* Parent Row */}
                    <tr
                      className="bg-white cursor-pointer hover:bg-[#f8f8f8] border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30"
                      onClick={() => toggleExpand(idx)}
                    >
                      <td className="py-1.5 px-2.5 text-center"></td>
                      <td className="py-1 px-2.5">
                        <span className="flex items-center gap-[5px]">
                          {" "}
                          {it.isExpand ? (
                            <IoIosRemoveCircleOutline size={16} />
                          ) : (
                            <IoIosAddCircleOutline size={16} />
                          )}
                          {it.title}
                        </span>
                      </td>
                      <td className="py-1 px-2.5"></td>
                      <td className="py-1 px-2.5"></td>
                      <td className="py-1 px-2.5"></td>
                    </tr>

                    {/* Child Rows (shown only when expanded) */}
                    {it.isExpand &&
                      it.children.map((child, idx2) => (
                        <tr
                          key={idx2}
                          className="bg-[#F1F1F1] font-light border-t border-[#C9C9C9]/30 divide-x divide-[#C9C9C9]/30"
                        >
                          <td className="py-1.5 px-2.5"></td>
                          <td className="py-1 px-2.5">
                            <span className="flex items-center gap-[5px]">
                              <MdOutlineArticle size={16} />
                              {child.number}-526-J-HS-3722
                            </span>
                          </td>
                          <td className="py-1 px-2.5">OFF</td>
                          <td className="py-1 px-2.5">OFF</td>
                          <td className="py-1 px-2.5">주급수펌프</td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </ResizableBox>
      {/* Information  */}
      <div className="flex flex-col gap-2.5">
        <div className="bg-white px-2.5 py-2">
          <h6 className="text-[#242424] text-[12px] font-bold">속성 정보</h6>
        </div>
        <div className="flex flex-col gap-2.5 px-2.5">
          {/* table  */}
          <div>
            {/* table data  */}
            <div className="w-full overflow-x-auto custom-scrollbar">
              <table className="text-[#242424] text-[12px] font-normal w-full text-center border border-[#B9B9B9]/30 whitespace-nowrap">
                <thead>
                  <tr className="bg-[#DBDBDB] divide-x divide-[#B9B9B9]/30">
                    <th className="px-2 py-1">속성</th>
                    <th className="px-2 py-1">값</th>
                  </tr>
                </thead>
                <tbody className="font-light">
                  {["", "", "", ""].map((_, idx) => (
                    <tr
                      key={idx}
                      className="border-t border-[#B9B9B9]/30 divide-x divide-[#B9B9B9]/30"
                    >
                      <td className="px-2 py-1">TAG_NO</td>
                      <td className="px-2 py-1">1-431-M-RV01</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
